"use client";

import React, { useEffect } from 'react';

const GoogleTagManager = () => {
  useEffect(() => {
    if (document.getElementById("alfa-gtag-G-XCG731P3ZQ")) {
      return;
    }

    const script = document.createElement('script');
    script.id = "alfa-gtag-G-XCG731P3ZQ";
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XCG731P3ZQ';
    script.async = true;

    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', 'G-XCG731P3ZQ');

  }, []);

  return null; // This component doesn't render anything visible in the UI
};

export default GoogleTagManager;
